import { useState } from 'react';
import { QuestionCircle } from '@doist/icons/brand';
import { Badge, ConditionalWrap, Text, Tooltip, useThrottledResize } from '@doist/marketist';
import Interpolate from '@doist/react-interpolate';
import cn from 'clsx';
import css from './feature-item.module.css';
export type FeatureItemProps = {
  name: string;
  description?: string;
  toggleVisible?: boolean;
  icon?: JSX.Element;
  iconColor?: 'primary' | 'secondary' | 'tertiary' | 'green' | 'yellow' | 'red';
  variant?: 'base' | 'sm';
  badge?: string;
};
export function FeatureItem({
  name,
  description,
  toggleVisible = true,
  icon,
  iconColor = 'secondary',
  variant = 'sm',
  badge
}: FeatureItemProps) {
  const [tooltipPlacement, setTooltipPlacement] = useState<'right' | 'bottom'>('right');
  useThrottledResize(() => {
    setTooltipPlacement(window.innerWidth < 480 ? 'bottom' : 'right');
    return () => {
      setTooltipPlacement(window.innerWidth < 480 ? 'bottom' : 'right');
    };
  });
  return <ConditionalWrap condition={typeof description === 'string'} wrap={children => <Tooltip title={<Text tag="span" size="body-2xs">
                            <Interpolate string={description} mapping={{
      br: <br />
    }} />
                        </Text>} followCursor placement={tooltipPlacement} className={cn(css.tooltip, css[variant])}>
                    {children}
                </Tooltip>} data-sentry-element="ConditionalWrap" data-sentry-component="FeatureItem" data-sentry-source-file="feature-item.tsx">
            <Text size={variant === 'base' ? 'body-sm' : 'body-xs'} weight="medium" className={css.featureItem} data-sentry-element="Text" data-sentry-source-file="feature-item.tsx">
                {icon ? <span className={cn(css.icon, css[iconColor])}>{icon}</span> : null}
                {name}
                {description && toggleVisible ? <QuestionCircle aria-hidden="true" className={cn(css.toggle)} /> : null}
                {badge ? <>
                        {' '}
                        <span className={css.badge}>
                            <Badge variant="beta">{badge}</Badge>
                        </span>
                    </> : null}
            </Text>
        </ConditionalWrap>;
}